import { appHttpService } from '@/services/standard/http-service';
import { models } from 'cesg-shared';

class AccountService {
  async getAll(): Promise<models.GetAccountsResponse[]> {
    const accounts = await appHttpService.request
      .url(`/accounts`)
      .get()
      .json<models.GetAccountsResponse[]>();
    return accounts;
  }
}

export const accountService = new AccountService();
